/**
 * Customizations to FullCalendar.
 */
(function (Drupal) {
  'use strict';

  Drupal.behaviors.fullCalendarScripts = {
    attach: function (context) {
      // Initialize the calendar modifications.
      if (document.readyState === 'complete') {
        var fcScriptsObject = this;
        document.querySelectorAll('.js-drupal-fullcalendar').forEach(function (eventCalendar) {
          fcScriptsObject.modifyCalendar(eventCalendar);
          eventCalendar.querySelectorAll('.fc-button-group button').forEach(function (button) {
            // Rerun if calendar is paged (this is why we don't use once()).
            button.addEventListener('click', function () {
              fcScriptsObject.modifyCalendar(eventCalendar);
            });
          });
        })
      }
    },
    modifyCalendar: function (eventCalendar) {
      // Homepage calendar: turn the month into a link to the Events page.
      if (eventCalendar.getAttribute('data-calendar-display') === 'home_calendar') {
        var calendarHeader = eventCalendar.querySelector('.fc-header-toolbar h2');
        if (typeof calendarHeader !== undefined && calendarHeader != null && calendarHeader.querySelectorAll('a').length === 0) {
          var headerText = calendarHeader.innerText;
          var headerTextParts = headerText.split(' ');
          headerText = headerTextParts[0].substring(0, 3) + ' ' + headerTextParts[1];
          calendarHeader.innerText = '';
          var headerLink = document.createElement('a');
          headerLink.href = window.location.href.replace(/\/$/, '') + '/events';
          headerLink.innerText = headerText;
          calendarHeader.append(headerLink);
        }
      }
      // For each day event, set up a tooltip so the whole event name can be seen.
      var fcEventContainers = eventCalendar.querySelectorAll('.fc-event-container .fc-day-grid-event');
      if (fcEventContainers.length !== 0) {
        fcEventContainers.forEach(function (element) {
          if (element.querySelectorAll('.fc-tooltip').length === 0) {
            var fcTime = element.querySelector('.fc-time');
            var fcTitle = element.querySelector('.fc-title');
            if (fcTime && fcTitle) {
              var fcTimeCopy = fcTime.cloneNode(true);
              var fcTitleCopy = fcTitle.cloneNode(true);
              fcTitleCopy.innerHTML = " " + fcTitleCopy.innerHTML;

              var toolTip = document.createElement('div');
              toolTip.className = 'fc-tooltip';
              toolTip.style.backgroundColor = element.style.backgroundColor;

              element.append(toolTip);
              toolTip.append(fcTimeCopy);
              toolTip.append(fcTitleCopy);
              // When the event is hovered or focused, show the tooltip.
              ['mouseenter', 'focus'].forEach(function(eventType) {
                element.addEventListener(eventType, function () {
                  toolTip.style.display = 'block';
                })
              });
              ['mouseleave', 'blur'].forEach(function(eventType) {
                element.addEventListener(eventType, function () {
                  toolTip.style.display = 'none';
                })
              });
            }
          }
        });
      }
    }
  };
})(Drupal);
